import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
export function FinalCTA() {
  return <section id="comprar" className="w-full bg-gradient-to-b from-mint to-mint-dark px-6 py-24 text-center text-white sm:px-10" data-id="element-58" data-mp="3ud6tv2u1xu4w">
      <div className="mx-auto max-w-2xl" data-id="element-59" data-mp="c83odh06bg3y">
        <h2 className="font-heading text-3xl font-bold leading-tight sm:text-4xl" data-id="element-60" data-mp="85fcf0g5xt2r">
          Empezá hoy a sentirte más liviana
          <span className="mt-2 block text-xl font-normal sm:text-2xl" data-id="element-61" data-mp="m3wxsrilithi">después de cada comida</span>
        </h2>

        <div className="mt-10" data-id="element-62" data-mp="h52hbw83ph0k">
          <p className="text-lg font-bold" data-id="element-63" data-mp="h414pnbfsmgq">245 recetas + 5 bonos (valor €175)</p>
          <p className="mt-2 text-sm text-white/85" data-id="element-64" data-mp="vtylvjay8bwf">
            6 tomos + planificador anual + listas de compra + reemplazos + etiquetas + diario
          </p>
        </div>

        <p className="mt-8 font-heading text-4xl font-bold text-amber" data-id="element-65" data-mp="14whk1q3si0cc">Hoy: solo €19</p>

        <a href="#" className="mt-8 inline-flex w-full items-center justify-center rounded-lg bg-coral px-10 py-5 text-xl font-bold text-white shadow-xl transition-colors duration-150 ease-out hover:bg-coral-dark sm:w-auto sm:min-w-[500px]" data-id="element-66" data-mp="zx4s4qy2a32w">
          Sí, quiero acceso ahora
        </a>

        <div className="mt-10 flex flex-col items-center gap-3 text-sm sm:flex-row sm:justify-center sm:gap-6" data-id="element-67" data-mp="2m218qjxnfzw3">
          <span className="flex items-center gap-2" data-id="element-68" data-mp="2r38j8qr6fd6g">
            <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-69" data-mp="2v4293po6j21z" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-70" data-mp="3023oo0mecj8p">
            <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-71" data-mp="300sk3yl4n7gj" /> Acceso inmediato tras compra
          </span>
          <span className="flex items-center gap-2" data-id="element-72" data-mp="34vey89ilfe4b">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="39rdhjip2e5xv" /> Garantía 7 días
          </span>
        </div>
      </div>
    </section>;
}